import classNames from "classnames";
import { IconColours } from "../../../../Foundation/Icons/interface";
import Icon, { IconNames } from "../../../../Foundation/Icons";
import LinkWrap from "../../../../shared/LinkWrap/component";
import { getFormattedDuration } from "../../../../../utils/dateTime/library";
import { VerticalToHorizontalCardProps } from "../../interface";
import { getImage } from "../../utils/GetImage";
import { shouldRenderStatus } from "../../utils/core-utils";
import { getBadge, getStatus } from "../../utils/GetFlags";
import classes from "./verticalToHorizontalCard.module.scss";
import { LIVE_FLAG_LABEL } from "./constants";

const AudioVideo = ({
    item,
    containerClasses,
    vthBreakpoints,
    showDescription = false,
    featureAttribution,
    onClick,
}: VerticalToHorizontalCardProps) => {
    const {
        title,
        url,
        description,
        image,
        videoDuration,
        external,
        itemType,
    } = item;
    const cx = classNames.bind(classes);

    const cardClasses = cx(
        classes.verticalToHorizontalCard,
        classes.audioVideo
    );
    const videoTime = getFormattedDuration(videoDuration ? videoDuration : 0);

    const ariaLabel = `${title ? title : ""}. Video Content. Duration: ${
        videoTime ? videoTime : ""
    }. Closed Captions available.`;

    const { status, label } = item.flags ?? {};

    return (
        <div
            className={`${containerClasses || ""} ${cardClasses}`}
            data-cy={`type-${itemType || ""}`}
        >
            <button
                className={classes.imageButton}
                onClick={() => onClick && onClick()}
                aria-label={ariaLabel}
            >
                <div className={classes.imageContainer}>
                    {getBadge(status, label, classes.vthBadge)}
                    {image &&
                        getImage(
                            { ...image, classNames: classes.vthImage },
                            vthBreakpoints
                        )}
                    <span className={classes.playButton}>
                        <Icon
                            type="filled"
                            name={IconNames.Play}
                            colour={IconColours.black}
                            ariaHidden={true}
                            size="26"
                        />
                    </span>
                    {status?.toLowerCase() !== LIVE_FLAG_LABEL && (
                        <div className={classes.videoTimeContainer}>
                            <span className={classes.videoTimeStamp}>
                                {videoTime}
                            </span>
                            <Icon
                                type="filled"
                                name={IconNames.ClosedCaptions}
                                colour={IconColours.white}
                                ariaHidden={true}
                                size="18"
                            />
                        </div>
                    )}
                </div>
            </button>
            <LinkWrap
                className={classes.link}
                url={url}
                external={external}
                featureAttribution={featureAttribution}
            >
                <h3 className={classes.headline}>
                    <div className={classes.headlineInner}>
                        {shouldRenderStatus(item) &&
                            getStatus(status, classes.status)}
                        <span className={classes.title}>{title}</span>
                    </div>
                </h3>
                {showDescription && (
                    <p className={classes.description}>{description}</p>
                )}
            </LinkWrap>
        </div>
    );
};

export default AudioVideo;
